export default class ProviderConstants {
    public static readonly ITEMS_PER_PAGE_COUNT = 100;
    public static readonly PROVIDERS_GRID_SYNC_STATUS_TITLE: string = "Sync Status";
    public static readonly PROVIDERS_GRID_NAME_TITLE: string = "Name";
    public static readonly PROVIDERS_GRID_ID_TITLE: string = "ID";
    public static readonly PROVIDERS_GRID_ABBREV_TITLE: string = "Abbreviation";
    public static readonly PROVIDERS_GRID_IS_CCCTITLE: string = "IsCCC";
    public static readonly PROVIDERS_GRID_OFFERING_TITLE: string = "Offering Type";
    public static readonly PROVIDERS_GRID_TRAINING_TITLE: string = "Training Type";
}